import { render, staticRenderFns } from "./TransferenciaComprador.vue?vue&type=template&id=7cd51557&"
import script from "./TransferenciaComprador.vue?vue&type=script&lang=js&"
export * from "./TransferenciaComprador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports